import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import Alert from 'react-bootstrap/Alert';
import Form from 'react-bootstrap/Form';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Spinner from 'react-bootstrap/Spinner';
import TWDelayConfirmation from './TWDelayConfirmation';
import { useContext } from 'react';
import CustomerContext from 'Components/CustomComponents/Context/CustomerContext';
import useFetchGet from 'Components/CustomComponents/Fetch/useFetchGet';
import useFetchPost from 'Components/CustomComponents/Fetch/useFetchPost';

function UploadDocuments({ show, setShow, employeeID }) {
    const { cookies } = useContext(CustomerContext)
    const [documentByteArray, setDocumentByteArray] = useState();
    const [selectedDocType, setSelectedDocType] = useState();
    const [fileName, setFileName] = useState();
    const [fileExtension, setFileExtension] = useState();
    const [canPost, setCanPost] = useState(false);
    const [showTWDelayConfirmation, setShowTWDelayConfirmation] = useState(false);
    const {REACT_APP_API_URL} = process.env;
    const { data: documentTypes, loading: loadingDocumentTypes} = useFetchGet(`${REACT_APP_API_URL}/Utilities/GetFormList?Token=${cookies.get('customer').Token}`, cookies)
    const { status, loading, error } = useFetchPost((canPost&&`${REACT_APP_API_URL}/Utilities/UploadEmployeeDoc?Token=${cookies.get('customer').Token}&filename=${fileName+'.'+fileExtension}&doctypeid=${selectedDocType.value.DocTypeID}&employeeid=${employeeID}`),cookies,documentByteArray)

    useEffect(()=>{
        if(status&&status===200){
            setShowTWDelayConfirmation(true);
        }
    },[status])

    const handleSubmit = () => { 
        if(selectedDocType&&fileName&&fileExtension&&documentByteArray){
            setCanPost(true)
        }
     }

    const handleClose = () => { 
        setShowTWDelayConfirmation(false);
        setShow(false)
     }

    const handleFileUpload = (e) =>{
        readFileDataAsBase64(e)
        .then(byteArray=>{
            setDocumentByteArray(byteArray.split(',')[1])
        })
    }

    const readFileDataAsBase64 = (e) => {
        const file = e.target.files[0];
        let splitFileName = file.name.split('.')
        console.log(splitFileName[splitFileName.length-1])
        setFileExtension(splitFileName[splitFileName.length-1])

        return new Promise((resolve, reject) => {
            const reader = new FileReader();
    
            reader.onload = (event) => {
                resolve(event.target.result);
            };
    
            reader.onerror = (err) => {
                reject(err);
            };
    
            reader.readAsDataURL(file);
        });
    }

    const handleFormChange = (e) => { 
        setFileName(e.value.FormName)
        setSelectedDocType(e)
     }

  return (
    <>
    {showTWDelayConfirmation&&<TWDelayConfirmation show={showTWDelayConfirmation} handleClose={handleClose} />}
    <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>Upload Documents</Modal.Header>
        <Modal.Body>
            <Form.Group className='margin-bottom' controlId="docType">
                <Form.Label>Form <span className="required">*</span></Form.Label>
                {loadingDocumentTypes?
                <Spinner animation='border' size='sm' />
                :
                <Select options={documentTypes&&documentTypes.map(docType=>{return{value:docType,label:docType.FormName}})} value={selectedDocType} onChange={(e)=>handleFormChange(e)} />
                }
            </Form.Group>

            {selectedDocType&&
            <>
            <Form.Group className='margin-bottom' controlId="documentType">
                <Form.Label>Document Type</Form.Label>
                <Form.Control disabled value={selectedDocType&&selectedDocType.value.description} />
            </Form.Group>
            <Form.Group className='margin-bottom' controlId="documentName">
                <Form.Label>Document Name</Form.Label>
                <Form.Control disabled value={fileName} />
            </Form.Group>
            <Form.Group className='margin-bottom' controlId="document">
                <Form.Label>Document <span className="required">*</span></Form.Label>
                <Form.Control type="file" onInput={(e)=>handleFileUpload(e)} />
            </Form.Group>
            </>
            }

            {error&&
            <Alert>{error}</Alert>
            }
        </Modal.Body>
        <Modal.Footer>
            <Button onClick={()=>handleSubmit()} disabled={!(selectedDocType&&fileName&&documentByteArray)}>{loading?<Spinner animation='border' size='sm'/>:'Submit'}</Button>
            <Button variant='secondary' onClick={()=>handleClose()}>Close</Button>
        </Modal.Footer>
    </Modal>
    </>
  )
}

export default UploadDocuments